(function () {
    // Schneefall-Konfiguration
    const config = {
        baseDimension: 1000,            // Basisdimension (Breite oder Höhe) für die Berechnung der Schneeflockenanzahl
        baseSnowflakeCount: 140,        // Anzahl der Schneeflocken bei der Basisdimension
        maxSnowflakeCount: 450,         // Maximale Anzahl der Schneeflocken
        minSize: 1.5,                   // Minimale Größe der Schneeflocken
        maxSize: 3.5,                   // Maximale Größe der Schneeflocken
        minSpeed: 0.5,                  // Minimale Fallgeschwindigkeit
        maxSpeed: 1.1,                  // Maximale Fallgeschwindigkeit
        windStrength: 0.6,              // Windstärke (positiv für nach rechts, negativ für nach links)
        windDirectionChange: 0.0065,    // Wahrscheinlichkeit der Windrichtungsänderung
        minOpacity: 0.1,                // Minimale Transparenz der Schneeflocken
        maxOpacity: 0.75,               // Maximale Transparenz der Schneeflocken
        showSnowflakeCount: false        // Zeigt links unten im Fenster die Anzahl der Schneeflocken an
    };

    // Initialisierung des Canvas und Schneeflocken
    const canvas = document.getElementById('snowCanvas');
    const ctx = canvas.getContext('2d');
    let width, height;
    let snowflakeCountDisplay;
    let animationFrameId; // Speichert die ID des Animation-Frames für die Steuerung

    // Schneeflocken-Array
    let snowflakes = [];

    // Fenstergröße ermitteln und die Anzahl der Schneeflocken proportional anpassen
    function resizeCanvas() {
        width = window.innerWidth;
        height = window.innerHeight;
        canvas.width = width;
        canvas.height = height;

        // Bestimme die längere Achse und berechne die Schneeflockenanzahl basierend darauf
        const longerDimension = Math.max(width, height);
        const targetSnowflakeCount = Math.min(
            Math.floor((longerDimension / config.baseDimension) * config.baseSnowflakeCount),
            config.maxSnowflakeCount
        );

        // Wenn die Anzahl sich geändert hat, Schneeflocken initialisieren
        if (snowflakes.length !== targetSnowflakeCount) {
            initializeSnowflakes(targetSnowflakeCount);
            updateSnowflakeCountDisplay(targetSnowflakeCount);
        }
    }

    // Schneeflocken-Objekt erzeugen
    function createSnowflake() {
        const size = Math.random() * (config.maxSize - config.minSize) + config.minSize;
        return {
            x: Math.random() * width,
            y: Math.random() * height,
            size: size,
            speed: Math.random() * (config.maxSpeed - config.minSpeed) + config.minSpeed,
            drift: Math.random() * config.windStrength * 2 - config.windStrength,
            opacity: Math.random() * (config.maxOpacity - config.minOpacity) + config.minOpacity // Transparenz innerhalb der Min-Max-Range
        };
    }

    // Schneeflocken initialisieren
    function initializeSnowflakes(targetCount) {
        snowflakes = [];
        for (let i = 0; i < targetCount; i++) {
            snowflakes.push(createSnowflake());
        }
    }

    // Schneeflocken bewegen
    function updateSnowflakes(deltaTime) {
        snowflakes.forEach(snowflake => {
            snowflake.y += snowflake.speed * deltaTime * 60;  // Multiplikator für gleiche Geschwindigkeit
            snowflake.x += snowflake.drift * deltaTime * 60;

            // Windrichtung zufällig ändern
            if (Math.random() < config.windDirectionChange) {
                snowflake.drift = Math.random() * config.windStrength * 2 - config.windStrength;
            }

            // Wenn die Schneeflocke den unteren Rand erreicht, wieder oben erscheinen lassen
            if (snowflake.y > height) {
                snowflake.y = -snowflake.size;
                snowflake.x = Math.random() * width;
            }
            // Wenn die Schneeflocke den Rand erreicht, auf die andere Seite wechseln
            if (snowflake.x > width) {
                snowflake.x = 0;
            } else if (snowflake.x < 0) {
                snowflake.x = width;
            }
        });
    }

    // Schneeflocken rendern
    function renderSnowflakes() {
        ctx.clearRect(0, 0, width, height);
        ctx.fillStyle = 'rgba(255, 255, 255, 0.8)';

        snowflakes.forEach(snowflake => {
            ctx.beginPath();
            ctx.arc(snowflake.x, snowflake.y, snowflake.size, 0, Math.PI * 2);
            ctx.closePath();
            ctx.globalAlpha = snowflake.opacity;
            ctx.fill();
        });

        ctx.globalAlpha = 1; // Alpha zurücksetzen
    }

    // Initiale Zeit setzen
    let lastTime = Date.now();

    // Animation starten
    function animate() {
        const now = Date.now();
        const deltaTime = (now - lastTime) / 1000;  // Berechnung der Zeitdifferenz in Sekunden
        lastTime = now;

        updateSnowflakes(deltaTime);
        renderSnowflakes();
        animationFrameId = requestAnimationFrame(animate);
    }

    // Pausiert die Animation
    function pauseAnimation() {
        if (animationFrameId) {
            cancelAnimationFrame(animationFrameId);
            animationFrameId = null;
        }
    }

    // Startet die Animation
    function startAnimation() {
        if (!animationFrameId) {
            lastTime = Date.now(); // Reset der Zeit, um nahtlose Fortsetzung zu ermöglichen
            animate();
        }
    }

    // Sichtbarkeitsänderung-Handler
    document.addEventListener('visibilitychange', function() {
        if (document.hidden) {
            pauseAnimation();
        } else {
            startAnimation();
        }
    });

    // Anzeige für Schneeflockenzähler hinzufügen
    function createSnowflakeCountDisplay() {
        if (config.showSnowflakeCount) {
            snowflakeCountDisplay = document.createElement('div');
            snowflakeCountDisplay.style.position = 'fixed';
            snowflakeCountDisplay.style.bottom = '10px';
            snowflakeCountDisplay.style.left = '10px';
            snowflakeCountDisplay.style.backgroundColor = 'red';
            snowflakeCountDisplay.style.color = 'white';
            snowflakeCountDisplay.style.padding = '5px 10px';
            snowflakeCountDisplay.style.borderRadius = '5px';
            snowflakeCountDisplay.style.fontFamily = 'Arial, sans-serif';
            snowflakeCountDisplay.style.fontSize = '14px';
            snowflakeCountDisplay.style.zIndex = '1000';
            document.body.appendChild(snowflakeCountDisplay);
        }
    }

    // Aktualisiert den Inhalt der Schneeflockenzählanzeige
    function updateSnowflakeCountDisplay(count) {
        if (config.showSnowflakeCount && snowflakeCountDisplay) {
            snowflakeCountDisplay.textContent = `Schneeflocken: ${count}`;
        }
    }

    // Event-Listener für die Größenänderung des Fensters
    window.addEventListener('resize', resizeCanvas);

    // Initialisierung
    resizeCanvas();
    const initialSnowflakeCount = Math.min(
        Math.floor((Math.max(width, height) / config.baseDimension) * config.baseSnowflakeCount),
        config.maxSnowflakeCount
    );
    initializeSnowflakes(initialSnowflakeCount);
    createSnowflakeCountDisplay();  // Fügt die Schneeflockenzählanzeige hinzu
    updateSnowflakeCountDisplay(initialSnowflakeCount);  // Zeigt die anfängliche Schneeflockenzahl an
    startAnimation(); // Animation starten
})();
